module.exports = __webpack_public_path__ + "img/cover.350bf4cc.svg";